// Import only Bootstrap components in use
import { Modal, Offcanvas } from 'bootstrap';

// Import Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import HTMX
import htmx from 'htmx.org';

// Import IMask
import IMask from 'imask';

// Make Bootstrap components available globally
window.bootstrap = {
  Modal,
  Offcanvas
};

// Make available globally
window.htmx = htmx;
window.IMask = IMask;

console.log('CMV App loaded');
